// Sizes

import {
  SeuBreakingChangesItem,
  SeuRevision,
  SeuRevisionCreateRequest,
} from '@seu-types';

export enum SEU_DIALOG_SIZE {
  S = '34rem',
  M = '46rem',
}

export enum SEU_DIALOG_MAX_SIZE {
  M = '94vw',
}

// Form Save Dialog

export type SeuFormCancelDialogInput = null;

export type SeuFormCancelDialogOutput = {
  action: 'save' | 'discard';
};

export type SeuFormCancelDialogType = 'discard' | 'cancel';

// Confirm Remove Dialog

export type SeuConfirmRemoveDialogInput = {
  labelKey:
    | 'default'
    | 'offer'
    | 'global-parameter'
    | 'operating-condition'
    | 'component'
    | 'input-stream'
    | 'rezirculation'
    | 'interconnection';
};

export type SeuActiveEditorErrorDialogInput = {
  header: string;
  text: string;
};

export type SeuConfirmRemoveDialogOutput = {
  action: 'remove' | 'cancel';
};

// Create Offer Dialog

export type SeuCreateOfferDialogInput = null;

export type SeuCreateOfferDialogOutput =
  | {
      action: 'created';
      offerId: string;
    }
  | {
      action: 'cancel';
    };

// Changelog Dialog

export type SeuChangelogDialogInput = {
  offerId: string;
  title: string;
};

export type SeuChangelogDialogOutput = null;

// Create Revision Dialog

export type SeuCreateRevisionDialogInput = {
  offerId: string;
};

export type SeuCreateRevisionDialogOutput =
  | {
      action: 'create';
      body: SeuRevisionCreateRequest;
    }
  | {
      action: 'cancel';
    };

// Check Revision Dialog

export type SeuCheckRevisionDialogInput = null;

export type SeuCheckRevisionDialogOutput =
  | {
      action: 'confirm';
    }
  | {
      action: 'cancel';
    };

// Revision Details Dialog

export type SeuRevisionDetailsDialogInput = {
  revision: SeuRevision;
};

export type SeuRevisionDetailsDialogOutput =
  | {
      action: 'restore';
      revisionId: string;
    }
  | {
      action: 'cancel';
    };

// Restore Revision Dialog

export type SeuRestoreRevisionDialogInput = {
  offerId: string;
  revisionId: string;
};

export type SeuRestoreRevisionDialogOutput =
  | {
      action: 'restored';
    }
  | {
      action: 'canceled';
    };

// Breaking Changes Dialog

export type SeuBreakingChangesDialogInput = {
  changeItems: SeuBreakingChangesItem[];
};

export type SeuBreakingChangesDialogOutput = null;
